import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { handleInputKeyPressForQtyAndValueInput, handleOnChangeForQtyAndValueInput, handleInputForQtyAndValueFocus } from '../../../Helpers/PriceAndValueInputHelpers';

const AddOwnPosition = ({ show, onHide }) => {
    const [name, setName] = useState(null)
    const [price, setPrice] = useState(null)
    const [errorText, setErrorText] = useState(null)

    useEffect(() => {
        if (!show) {
            setName(null)
            setPrice(null)
            setErrorText(null)
        }
    }, [show])

    const handleAddPosition = () => {
        if (!name || name.trim() === '') {
            setErrorText('Podaj nazwę pozycji')
            return
        }
        if (!price || price.trim() === '') {
            setErrorText('Podaj cene pozycji')
            return
        }
        onHide({ name: name, price: price })
    }
    const handleNameChange = (e) => {
        setName(e.target.value)
        setErrorText(null)
    }
    const handleInputKeyPress = (e) => {
        if (!handleInputKeyPressForQtyAndValueInput(e, 2)) {
            e.preventDefault()
            return
        }
    }
    const handlePriceChange = (e) => {
        if (!handleOnChangeForQtyAndValueInput(e, 2)) {
            e.preventDefault()
            return
        }
        setPrice(e.target.value)
    }
    const handlePriceLostFocus = (e) => {
        e.target.value = parseFloat(e.target.value).toFixed(2)
    }

    return (
        <Modal size='lg' show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Wprowadź dane własnej pozycji</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Control placeholder='Nazwa' className='mb-3' value={name} maxLength={76} onChange={(e) => handleNameChange(e)} />
                <Form.Control placeholder='Cena netto' type='number' min={0} max={99999} value={price} onKeyDown={handleInputKeyPress} onChange={handlePriceChange} step={Math.pow(10, -2)}
                    onFocus={(e) => handleInputForQtyAndValueFocus(e, false)} onBlur={handlePriceLostFocus} />
                <div className={`d-flex justify-content-center mt-3 mb-3`}>
                    <span className='error-text-color'>{errorText}</span>
                </div>
                <div className="d-flex flex justify-content-end  mt-4">
                    <button className='btn-app-primary me-3' onClick={handleAddPosition}>Dodaj</button>
                    <button className='btn-app-secondary' onClick={() => onHide(null)}>Anuluj</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddOwnPosition